import React from 'react';
import { takeLatest, put, call } from 'redux-saga/effects';

import { toast } from 'react-toastify';
import { LOADER_CLOSE, LOADER_OPEN } from '../actions';

import {
  ADD_USER_TO_SESSION,
  BBB_ENABLED_GET,
  BBB_URL_GET,
  CHECK_EVENT_TUTOR,
  EVENT_DATES_LIST_GET,
  EVENT_DETAILS_GET,
  GET_USERS_BY_SESSION,
  JOIN_BBB_SESSION,
  SESSIONS_LIST_GET,
  SESSION_REGISTRATION_SET,
} from '../actions/events';
import events from '../../api/events';
import { ToastSuccess } from '../../../ui/components/Toast';
import { formatPermissions } from '../../../utils/permissions';
import { PERMISSION_SET } from '../actions/permissions';
import { COURSE_DETAILS_GET } from '../actions/coursedetails';

function* getEventDates({ filters = {} }) {
  try {
    const { data: { data: response } = {} } = yield call(
      events.sessionsListGet,
      filters
    );
    yield put({ type: EVENT_DATES_LIST_GET._SUCCESS, response });
  } catch (error) {
    yield put({ type: EVENT_DATES_LIST_GET._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > getEventsDates', error);
  }
}

function* getEventDatesWatch() {
  yield takeLatest(EVENT_DATES_LIST_GET._REQUEST, getEventDates);
}

function* sessionsListGet({ filters = {}, keepAllSessions = false }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      events.sessionsListGet,
      filters
    );
    yield put({ type: SESSIONS_LIST_GET._SUCCESS, response, keepAllSessions });
  } catch (error) {
    yield put({ type: SESSIONS_LIST_GET._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > sessionsListGet', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* sessionsListGetWatch() {
  yield takeLatest(SESSIONS_LIST_GET._REQUEST, sessionsListGet);
}

function* getEventDetails({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      events.getEventDetails,
      id
    );
    yield put({ type: EVENT_DETAILS_GET._SUCCESS, response });
    const eventPermissions = formatPermissions(response?.permissions);
    yield put({ type: PERMISSION_SET, data: eventPermissions });
  } catch (error) {
    yield put({ type: EVENT_DETAILS_GET._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > getEventDetails', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getEventDetailsWatch() {
  yield takeLatest(EVENT_DETAILS_GET._REQUEST, getEventDetails);
}

function* sessionRegistration({ sessionId, activityId, eventId }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      events.sessionRegistration,
      sessionId,
      activityId
    );
    if (response?.result !== null) {
      yield put({ type: SESSION_REGISTRATION_SET._SUCCESS });
      yield put({ type: COURSE_DETAILS_GET._REQUEST, id: eventId });
    }
  } catch (error) {
    yield put({ type: SESSION_REGISTRATION_SET._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > sessionRegistration', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* sessionRegistrationWatch() {
  yield takeLatest(SESSION_REGISTRATION_SET._REQUEST, sessionRegistration);
}

function* checkEventTutor({ sessionId }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      events.checkEventTutor,
      { sessionId }
    );
    yield put({ type: CHECK_EVENT_TUTOR._SUCCESS, response });
  } catch (error) {
    yield put({ type: CHECK_EVENT_TUTOR._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > checkEventTutor', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* checkEventTutorWatch() {
  yield takeLatest(CHECK_EVENT_TUTOR._REQUEST, checkEventTutor);
}

function* getUsersBySession({ sessionId }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      events.getUsersBySession,
      { sessionId }
    );
    yield put({ type: GET_USERS_BY_SESSION._SUCCESS, response });
  } catch (error) {
    yield put({ type: GET_USERS_BY_SESSION._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > getUsersBySession', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getUsersBySessionWatch() {
  yield takeLatest(GET_USERS_BY_SESSION._REQUEST, getUsersBySession);
}

function* addUserToSession({ userId, sessionId, name }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      events.addUserToSession,
      { userId, sessionId }
    );
    if (response?.result) {
      yield put({ type: ADD_USER_TO_SESSION._SUCCESS });
      yield put({ type: GET_USERS_BY_SESSION._REQUEST, sessionId });
      toast.success(<ToastSuccess title="Utente aggiunto" body={name} />, {
        toastId: `addUser-${name}`,
      });
    }
  } catch (error) {
    yield put({ type: ADD_USER_TO_SESSION._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > addUserToSession', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* addUserToSessionWatch() {
  yield takeLatest(ADD_USER_TO_SESSION._REQUEST, addUserToSession);
}

function* joinBBBSession({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      events.joinBBBSession,
      id
    );
    yield put({ type: JOIN_BBB_SESSION._SUCCESS, response });
  } catch (error) {
    yield put({ type: JOIN_BBB_SESSION._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > joinBBBSession', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* joinBBBSessionWatch() {
  yield takeLatest(JOIN_BBB_SESSION._REQUEST, joinBBBSession);
}

function* bbbEnabledGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(events.bbbEnabledGet);
    yield put({ type: BBB_ENABLED_GET._SUCCESS, response });
  } catch (error) {
    yield put({ type: BBB_ENABLED_GET._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > bbbEnabledGet', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* bbbEnabledGetWatch() {
  yield takeLatest(BBB_ENABLED_GET._REQUEST, bbbEnabledGet);
}

function* bbbUrlGet({ title }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      events.bbbUrlGet,
      title
    );
    yield put({ type: BBB_URL_GET._SUCCESS, response });
  } catch (error) {
    yield put({ type: BBB_URL_GET._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > bbbUrlGet', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* bbbUrlGetWatch() {
  yield takeLatest(BBB_URL_GET._REQUEST, bbbUrlGet);
}

export default [
  getEventDatesWatch(),
  sessionsListGetWatch(),
  getEventDetailsWatch(),
  sessionRegistrationWatch(),
  checkEventTutorWatch(),
  getUsersBySessionWatch(),
  addUserToSessionWatch(),
  joinBBBSessionWatch(),
  bbbEnabledGetWatch(),
  bbbUrlGetWatch(),
];
